import { NgModule } from '@angular/core';
import { LocalizationComponent } from './localization.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { LocalizationSettingsComponent } from './localization-settings/localization-settings.component';
import { LocalizationRoutingModule } from './localization-routing.module';
import { LocalizationGridComponent } from './localization-grid/localization-grid.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

@NgModule({
    declarations: [
        LocalizationComponent,
        LocalizationGridComponent,
        LocalizationSettingsComponent
    ],
    imports : [
        CommonModule,
        SharedModule,
        LocalizationRoutingModule,
        GridModule,
        DropDownsModule,
        InputsModule,
        FormsModule,
        ReactiveFormsModule,
        NgbDropdownModule,
        NgMultiSelectDropDownModule.forRoot(),
    ],
})
export class LocalizationModule {}
